import { classNames } from "@op/opds.opux"
import React from "react"
import { ReactComponent } from "../svgs/illustration-insurance-category-vehicles.svg"

const IconCategoryVehicles = ({ className, ...props }) => (
  <ReactComponent aria-hidden={true} {...props} className={classNames("insurance-icon", className)} />
)

IconCategoryVehicles.displayName = "IconCategoryVehicles"
export default IconCategoryVehicles
